export const getUserInitials = (
    lastName: string,
    firstName?: string,
    middleName?: string
): string => {
    let initials = firstName ? firstName.charAt(0).toUpperCase() + '.' : '';
    initials += middleName ? middleName.charAt(0).toUpperCase() + '.' : '';

    return `${lastName} ${initials}`;
};
